<template>
  <div>
    <v-card flat tile color="Neutral">
      <v-card color="Neutral" flat tile>
        <v-card-text>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="12" md="7" lg="8" class="pt-1 pb-0">
              <div>
                <h6 class="subtitle-2">{{ $t("poll.lblRespondent") }}</h6>
              </div>
              <v-list-item>
                <v-list-item-icon class="mr-6 ml-3 mt-0 mb-0">
                  <h1 class="primary--text">
                    {{ selectedResponse.resNo }}
                  </h1>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-select
                    v-model="selectedResponse"
                    :items="respondentList"
                    :rules="[(v) => !!v || $t('poll.ruleRequired')]"
                    item-text="userid"
                    item-value="resId"
                    :label="$t('poll.lblSelectRespondent')"
                    return-object
                    outlined
                    solo
                    dense
                    :menu-props="{ bottom: true, offsetY: true }"
                  >
                    <template slot="no-data">
                      <span class="ml-3 subtitle-2"
                        ><strong>{{ $t("poll.msgNoResponses") }}</strong></span
                      >
                    </template>
                  </v-select>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" sm="12" md="5" lg="4">
              <v-list-item v-if="false">
                <v-list-item-content>
                  <div>
                    <div><h1 class="pageHeader--text">00.50</h1></div>
                    {{ $t("poll.lblTimeToComplete") }}
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <div v-if="isSectionWiseDisplay">
          <SurveyQuestionsWithSection
            v-if="surveyType === 'survey'"
            :surveyQuestions="surveyResDetails"
            :isReadOnly="true"
            :tab="tab"
          ></SurveyQuestionsWithSection>
        </div>
        <div v-else>
          <survey-questions
            v-if="surveyType === 'survey'"
            :surveyQuestions="surveyResDetails"
            :isReadOnly="true"
            :tab="tab"
          ></survey-questions>
          <poll-question
            v-else
            :surveyQuestions="surveyResDetails"
            :isReadOnly="true"
            :tab="tab"
          ></poll-question>
        </div>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SurveyQuestions from "./SurveyQuestions.vue";
import PollQuestion from "./PollQuestion.vue";
import SurveyQuestionsWithSection from "./SurveyQuestionsWithSections.vue";
import _ from "lodash";

export default {
  name: "SurveyResult",
  components: { SurveyQuestions, PollQuestion, SurveyQuestionsWithSection },
  data() {
    return {
      selectedResponse: "",
      surveyResDetails: null,
    };
  },
  props: {
    surveyDetails: {
      type: [Object, Array],
    },
    tab: {
      type: String,
      default: 'question',
    },
  },
  watch: {
    async selectedResponse(val) { 
      this.updateRespondentResult();
    },
  },
  async created(){
     this.$root.$on("reset-respondent", (id) => {
      this.resetRespondent();
     });
    this.$root.$on("refresh-signalR", async (id) => {
      this.updateRespondentResult();
    });
  },
  beforeDestroy() {
    this.$root.$off("reset-respondent");
    this.$root.$off("refresh-signalR");
  },
  computed: {
    ...mapState({
      surveyResponseResult: (state) => state.poll.surveyResponseResult,
    }),
    surveyTitle() {
      return this.surveyDetails ? this.surveyDetails.title : "Loading...";
    },
    surveyType() {
      if (this.surveyDetails) {
        return this.surveyDetails.type;
      }
      return "survey";
    },
    isSectionWiseDisplay() {
      if (!this.surveyDetails.sections) {
        return false;
      }
      if (this.surveyDetails.sections.length > 0) {
        return true;
      }

      return false;
    },
    isAnonymousSurvey() {
      if (this.surveyDetails) {
        return this.surveyDetails.isAnonymous;
      }
      return false;
    },
    respondentList() {
      let responseList = [];
      let index = 1;
      if(this.surveyResponseResult && this.surveyResponseResult.length > 0){
        this.surveyResponseResult.forEach((res) => {
          const resName = res.userName
            ? `${res.userName} (${res.userid})`
            : res.userid;
          responseList.push({
            resNo: index,
            userid: this.isAnonymousSurvey
              ? this.$t("poll.lblUserRespondent", { number: index.toString() })
              : resName,
            resId: res.id,
            surveyid: res.surveyid,
          });
          index = index + 1;
        });
      }
      if (responseList.length > 0 && !this.selectedResponse) {
        this.selectedResponse = responseList[0];
      }
      return responseList;
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
  },
  methods: {
    ...mapActions({
      getSurveyById: "poll/getSurveyById",
      getResponseBySurveyId: "poll/getResponseBySurveyId",
    }),
    updateRespondentResult,
    resetRespondent() {
      if (this.respondentList.length > 0) {
        this.selectedResponse = this.respondentList[0];
      }
    },
  },
};

function updateRespondentResult() {
  // Clone survey details to survey response details
  this.surveyResDetails = _.cloneDeep(this.surveyDetails);

  // Find the survey response matching the selected respondent's ID
  const surveyResponse = this.surveyResponseResult.find(
    (response) => response.id === this.selectedResponse.resId
  );
  // Helper function to get the answer for each question
  const getAnswerForQuestion = (questionId) => {
    if (!surveyResponse) return null; // Handle the case where surveyResponse doesn't exist

    const answerObj = surveyResponse.questionAnswers.find(
      (answer) => answer.questionId === questionId
    );
    
    return answerObj?.answer || null;
  };
  // Iterate over survey questions and update selected answers
  this.surveyResDetails.questions.forEach((question) => {
    //question.isMandatory = false;
    question.selectedAnswer = getAnswerForQuestion(question.id); // Safely assign selectedAnswer
  });
}



</script>

<style>
</style>